import { useCallback } from 'react';
import { type NavigateOptions, useLocation, useNavigate } from 'react-router';
import { routes } from 'routes/routes';
import type { GroupDetailScope } from 'features/groups';

export const useNavigateToGroupDetailPageByKey = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return useCallback(
    async ({ id, key, navigateOptions }: { id: string; key?: GroupDetailScope; navigateOptions?: NavigateOptions }) => {
      const path = routes.group.detail.scope(id, key);

      if (path !== location.pathname) {
        await navigate(path, navigateOptions);
      }
    },
    [location.pathname, navigate],
  );
};
